/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { MatSortHeader } from './sort-header';
import { MatSort } from './sort';
import { MatSortHeaderIntl } from './sort-header-intl';
import { CommonModule } from '@angular/common';
export class MatSortModule {
}
MatSortModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [MatSort, MatSortHeader],
                declarations: [MatSort, MatSortHeader],
                providers: [MatSortHeaderIntl]
            },] },
];
/**
 * @nocollapse
 */
MatSortModule.ctorParameters = () => [];
function MatSortModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatSortModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatSortModule.ctorParameters;
}
//# sourceMappingURL=sort-module.js.map